import NewShiurim from '../NewSiurim'
import { Wrapper } from './styled'

type Props = { openRegisterToContinueModal: () => void }

// Recommended section hidden for now; Daily Shiurim takes the full width.
// The /recommended route + query remain, so it can be re-enabled by
// restoring the <Recommended /> render here.
function NewAndRecommended({ openRegisterToContinueModal }: Props) {
  return (
    <Wrapper>
      <NewShiurim openRegisterToContinueModal={openRegisterToContinueModal} />
    </Wrapper>
  )
}

export default NewAndRecommended
